import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminSocialMedia = lazy(() => import("@/pages/admin/AdminSocialMedia"));

export const Route = createFileRoute("/admin/sociala-medier")({
  component: () => <AdminSocialMedia />,
});
